import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { version } from '../../../../package.json';

@Component({
    standalone: true,
    selector: 'app-footer',
    imports: [RouterModule],
    template: `
        <div class="layout-footer">
            <div class="px-6 py-5">
                <!-- Top row: brand + legal links -->
                <div class="flex flex-col lg:flex-row items-center justify-between gap-4">
                    <!-- Brand -->
                    <div class="flex items-center gap-3">
                        <div
                            class="w-8 h-8 rounded-lg flex items-center justify-center"
                            style="background: var(--p-primary-color)"
                        >
                            <i class="pi pi-clock text-white text-sm"></i>
                        </div>
                        <span class="font-semibold" style="color: var(--p-text-color)">
                            Mi Jornada
                        </span>
                        <span
                            class="text-xs px-2 py-0.5 rounded-full"
                            style="background: var(--p-content-hover-background); color: var(--p-text-muted-color)"
                        >
                            v{{ appVersion }}
                        </span>
                    </div>

                    <!-- Legal links -->
                    <nav class="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm">
                        <a
                            [routerLink]="['/auth/declaracion-privacidad']"
                            target="_blank"
                            class="footer-link"
                        >
                            <i class="pi pi-shield text-xs"></i>
                            Privacidad
                        </a>
                        <span class="footer-separator"></span>
                        <a
                            [routerLink]="['/auth/terminos-condiciones']"
                            target="_blank"
                            class="footer-link"
                        >
                            <i class="pi pi-file text-xs"></i>
                            Términos y condiciones
                        </a>
                        <span class="footer-separator"></span>
                        <a
                            [routerLink]="['/auth/autorizacion-datos']"
                            target="_blank"
                            class="footer-link"
                        >
                            <i class="pi pi-lock text-xs"></i>
                            Tratamiento de datos
                        </a>
                    </nav>
                </div>

                <!-- Divider -->
                <div
                    class="my-4 border-t"
                    style="border-color: var(--p-content-border-color)"
                ></div>

                <!-- Bottom row: copyright + powered by -->
                <div class="flex flex-col sm:flex-row items-center justify-between gap-2 text-xs" style="color: var(--p-text-muted-color)">
                    <span>&copy; {{ currentYear }} Virtual Araucano. Todos los derechos reservados.</span>
                    <span class="flex items-center gap-1.5">
                        <i class="pi pi-check-circle" style="color: var(--p-primary-color)"></i>
                        Cumplimiento normativo laboral colombiano
                    </span>
                </div>
            </div>
        </div>
    `,
    styles: [
        `
            .footer-link {
                display: inline-flex;
                align-items: center;
                gap: 0.375rem;
                color: var(--p-text-muted-color);
                transition: color 0.2s ease;
                text-decoration: none;
            }

            .footer-link:hover {
                color: var(--p-primary-color);
            }

            .footer-separator {
                display: none;
            }

            @media (min-width: 640px) {
                .footer-separator {
                    display: block;
                    width: 1px;
                    height: 14px;
                    background: var(--p-content-border-color);
                }
            }
        `,
    ],
})
export class AppFooter {
    currentYear = new Date().getFullYear();
    appVersion = version;
}
